module.exports = __webpack_public_path__ + "static/media/un-fixed.3737e8c6.svg";